/* eslint-disable react/prop-types */
import React from "react";
import {
  Box,
  makeStyles,
  useMediaQuery,
  Typography,
  withStyles,
} from "@material-ui/core";
import CardComponent from "app/common/CardComponent";

const useStyles = makeStyles(() => ({
  root: {
    width: "auto",
    flexWrap: "wrap",
    display: "flex",
    maxHeight: "inherit",
    overflowY: "auto",
  },
  rootSmall: {
    width: "auto",
    flexWrap: "wrap",
    display: "flex",
    maxHeight: "inherit",
    overflowY: "auto",
  },
}));

const StyledTypography = withStyles(() => ({
  root: { paddingRight: "5px", fontSize: "14px" },
}))(Typography);

const DescriptionError = ({ fieldsData }) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const classes = useStyles();
  return (
    <CardComponent
      styleCardImportCsv
      withoutPadding
      body={
        <Box className={isSmallScreen ? classes.rootSmall : classes.root}>
          <StyledTypography variant="body1">{fieldsData}</StyledTypography>
        </Box>
      }
    />
  );
};

export default DescriptionError;
